namespace('compass.hotel');

compass.hotel.GroupLandingCustomizationWidget = compass.defineWidget(function GroupLandingCustomizationWidget(options) {
	var me = this;
	var $j = jQuery;

	var _settings = options;

	var _hotel = _settings.hotel;

	_validator = null;

	this.validate = function() {
		this.validator.validateAll();
		return this.validator.valid;
	};

	var _setupControls = this.setupControls = function() {

	};

	var _getData = this.getData = function () {
		var data = {};
		data.message = this.find('textarea').val();		
		data.options = {
			'credit_card': this.find(':checkbox[name=\"credit_card\"]').prop('checked'),
			'change_dates': false,
			'cancel': false
		};

		return data;
	};

	var _render = this.render = function(widgetElem) {
		var d = _d;
		widgetElem.append(
			me.drawCustomMessage(),
			me.drawTextEditor(),
			me.drawRules()
		);
		
		_setupControls();
	};

	this.drawCustomMessage = function() {
		var d = _d;
		var customMessage =
		d.div(d.div({
				className : 'header'
			}, 'Custom Message'),
			d.div('This message will appear on the group member landing page.')
		);

		return customMessage;
	};

	this.drawTextEditor = function() {
		var d = _d;
		return d.textarea(_settings.values.welcome_message);
	};


	this.drawRules = function() {
		var d = _d;
		var customMessage =
		d.div(d.div({
				className : 'header'
			}, 'Rules'),
			d.input({ type : 'checkbox', name: 'credit_card', checked: _settings.values.rules.creditCard }), d.span('Group members must add their own credit card.'), d.br(),
			d.br()
		);
		return customMessage;
	};

	this.drawCancelPolicy = function() {
		var d = _d;
		return d.div({
			className : 'CancelPolicy'
		}, 'You have until 72 hours before your arrival date to cancel RISK FREE.  If you cancel within 72 hours of your arrival you will be subject to a penalty in the amount of one night\'s stay plus tax, or forfeiture of the deposit paid.');
	};


	this.drawChangesPolicyHeader = function() {
		var d = _d;
		return d.div({
			className : 'changesPolicyHeader'
		}, 'CAN I MAKE CHANGES?');
	};

	this.drawChangesPolicy = function() {
		var d = _d;
		return d.div({
			className : 'changesPolicy'
		}, 'Absolutely.  Any time before #DATE# you can adjust your stay to your heart\'s content.');
	};

	this.drawBackButton = function() {
		var d = _d;
		return d.button({
			className : 'backButton'
		}, 'Take me back.').activate(function(){me.trigger('GroupLandingCustomizationWidget.backClicked');});
	};

	var _d = jQuery.dom.getContext(this);

}, {
	WUID : 'CRAP',
	widgetName : 'GroupLandingCustomizationWidget',
	imgPath : '/resources/img',
	subclass : false,
	values: {
		welcome_message: "",
		rules: {
			creditCard: false
		}
	}
});

